import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { VisibleForRoleDirective, AuditorSimulationModeDirective } from './directives';
import {
  AbstractAuthConfigService,
  AbstractAuthEventService,
  AuthGuardService, AuthService,
  FirebaseWrapperService,
  RoleService,
  TenantFacadeService,
  TenantService,
  TenantSubDomainExtractorService,
  AuthNavigatorService,
  PermissionsApiService,
  AuthDecoratorService,
  AuditorSimulationService
} from './services';
import { AuthCallbackComponent, TokenCallbackComponent } from './components';
import { AuthCallbackGuard } from './services/auth-callback-guard/auth-callback.guard';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { featureStateKey, reducers } from './store/state';
import { AuthEffects } from './store/effects';
import { IS_EXTERNAL_PAGE_TOKEN } from './constants';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(featureStateKey, reducers),
  ],
  declarations: [
    VisibleForRoleDirective,
    AuthCallbackComponent,
    TokenCallbackComponent,
    AuditorSimulationModeDirective,
  ],
  exports: [VisibleForRoleDirective, AuditorSimulationModeDirective]
})
export class AuthCoreModule {
  static forRoot(configuration: {
    configType: Type<AbstractAuthConfigService>,
    authEventType: Type<AbstractAuthEventService>,
    isExternalPage?: boolean,
  }): ModuleWithProviders<AuthCoreModule> {
    return {
      ngModule: AuthCoreModule,
      providers: [
        {
          provide: AuthService,
          useClass: AuthDecoratorService // TODO: Since we still use old "role" approach this will take user role from permissions api
        },
        RoleService,
        AuthGuardService,
        FirebaseWrapperService,
        TenantService,
        TenantFacadeService,
        TenantSubDomainExtractorService,
        AuthNavigatorService,
        AuthCallbackGuard,
        PermissionsApiService,
        AuditorSimulationService,
        {
          provide: AbstractAuthConfigService,
          useClass: configuration.configType
        },
        {
          provide: AbstractAuthEventService,
          useClass: configuration.authEventType
        },
        { provide: IS_EXTERNAL_PAGE_TOKEN, useValue: configuration.isExternalPage },
        ...EffectsModule.forFeature([AuthEffects]).providers
      ],
    };
  }
}
